import { GraphQlClient, Auth, Storage } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getLogin(context, params) {
    return GraphQlClient.query(`
      query($email: String!, $password: String!) {
        login(
          email: $email,
          password: $password,
        ) {
          authf2
          client {
            id
            sandbox_id
          }
          user {
            migrated
            id
            company_id
            first_name
            last_name
            email
            position
            token
            enabled
            blocked
            is_production
            created
            created_iso
            modified
            modified_iso
            last_login
            last_login_iso
            user_group_id
            external_id
            time_zone_id
            allow_password_change_from_api
            warehouse_ids
            access_token
            hide_environment
            profiles
            security {
              token_timeout_inactivity,
              expired_password_in_days,
              time,
              hash_password,
            }
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { login = {} } = data;
      return Promise.resolve(login);
    });
  },
  getTwoFactorCode(context, params) {
    return GraphQlClient.query(`
      query($email: String!) {
        getTwoFactorCode(
          email: $email,
        ) {
          message
        }
      }`, params)
    .then(({ data = {} }) => {
      const { getTwoFactorCode = {} } = data;
      const { message } = getTwoFactorCode;
      ScToast.success(message);
      return Promise.resolve(getTwoFactorCode);
    });
  },
  getEmailCheck(context, params) {
    const { email } = params;
    return GraphQlClient.query(`
      query($email: String!) {
        emailCheck(
          email: $email,
        ) {
            cognitoUserpool,
            cognitoClientId,
            cognitoAppDomain,
            enable_sso
          }
      }`, { email })
    .then(({ data = {} }) => {
      const { emailCheck = {} } = data;
      Storage.remove('cognito_data');
      if (emailCheck.enable_sso) {
        const authData = {
          ClientId: emailCheck.cognitoClientId,
          AppWebDomain: emailCheck.cognitoAppDomain,
          TokenScopesArray: ['openid', 'email'],
          RedirectUriSignIn: process.env.LOGIN_SSO_URL,
          RedirectUriSignOut: process.env.LOGOUT_SSO_URL,
          UserPoolId: emailCheck.cognitoUserpool,
        };
        Storage.set('cognito_data', authData, 'local');
      }
      ScToast.success('Verificação realizada com sucesso!');
      return Promise.resolve(emailCheck);
    }).catch(err => Promise.reject(err));
  },
  getLoginTwoFactorAuth(context, params) {
    return GraphQlClient.query(`
      query($email: String!, $twoFactorCode: String!) {
        getLoginTwoFactorAuth(
          email: $email,
          twoFactorCode: $twoFactorCode,
        ) {
          client {
            id
            sandbox_id
          }
          user {
            id
            company_id
            first_name
            last_name
            email
            is_production
            warehouse_ids
            access_token
            hide_environment
            security {
              token_timeout_inactivity
            }
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { getLoginTwoFactorAuth = {} } = data;
      return Promise.resolve(getLoginTwoFactorAuth);
    });
  },
  getLoginCiashop(context, params) {
    return GraphQlClient.query(`
      query {
        login(
          $email: String!,
          $password: String!,
          $code: String!,
          $shop: String!,
        ) {
          client {
            id
            sandbox_id
          }
          user {
            id
            company_id
            first_name
            last_name
            email
            phone
            cell_phone
            position
            token
            enabled
            blocked
            is_production
            created
            created_iso
            modified
            modified_iso
            last_login
            last_login_iso
            user_group_id
            external_id
            time_zone_id
            allow_password_change_from_api
            warehouse_ids
          }
        }
      }`, params)
    .then(({ data = {} }) => {
      const { login = {} } = data;
      return Promise.resolve(login);
    });
  },
  getBearerToken(context, params) {
    return GraphQlClient.query(`
      query($jwtToken: String!, $user: String!) {
        getBearerToken(
          jwtToken: $jwtToken,
          user: $user
        ){
          authf2
          client {
            id
            sandbox_id
          }
          user {
            migrated
            id
            company_id
            first_name
            last_name
            email
            is_production
            warehouse_ids
            access_token
            hide_environment
            profiles
            security {
              token_timeout_inactivity
            }
          }
        }
      }`, params)
    .then((response) => {
      const { getBearerToken } = response.data;
      return Promise.resolve(getBearerToken);
    })
    .catch(err => Promise.reject(err));
  },
  getLogout() {
    const { email } = Auth.getUser();
    const params = {
      email,
    };
    return GraphQlClient.query(`
      query ($email: String!) {
        logout(email: $email) {
          ok
        }
      }`, params)
    .then(({ data = {} }) => {
      const { logout = {} } = data;
      return Promise.resolve(logout);
    });
  },
  getResetPasswordRules(context, params) {
    return GraphQlClient.query(`
      query($id: Int!, $time: Float!, $hash: String!) {
        resetPasswordRules(
          id: $id,
          time: $time,
          hash: $hash,
        ) {
          rules {
            ruleDescription
            regex
          }
          passwordMinLength
        }
      }`, params)
    .then((res) => {
      const { data = {} } = res;
      return Promise.resolve(data);
    });
  },
  getValidateLink(context, params) {
    return GraphQlClient.query(`
      query($id: Int!, $time: Float!, $hash: String!) {
        getValidateLink(
          id: $id,
          time: $time,
          hash: $hash,
        ) {
          user {
            email
          }
        }
      }`, params)
    .then(({ data: { getValidateLink } }) => Promise.resolve(getValidateLink))
    .catch(err => Promise.reject(err));
  },
  updatePasswordMigrated(context, params) {
    return GraphQlClient.mutation(
      `mutation(
        $id: Int!
        $time: Float!
        $hash: String!
        $new_password: String!
      ) {
        resetPasswordMigrated (
          id: $id
          time: $time
          hash: $hash
          new_password: $new_password
        ) {
          status
          message
        }
      }`, params)
    .then(({ data = {} }) => {
      const { resetPasswordMigrated = {} } = data;
      const { message = '' } = resetPasswordMigrated;
      ScToast.success(message);
      return Promise.resolve(resetPasswordMigrated);
    });
  },
  updatePassword(context, params) {
    return GraphQlClient.mutation(
      `mutation(
        $id: Int!
        $time: Float!
        $hash: String!
        $new_password: String!
      ) {
        resetPassword (
          id: $id
          time: $time
          hash: $hash
          new_password: $new_password
        ) {
          status
          message
        }
      }`, params)
    .then(({ data = {} }) => {
      const { resetPassword = {} } = data;
      const { message = '' } = resetPassword;
      ScToast.success(message);
      return Promise.resolve(resetPassword);
    });
  },

  forgotPassword(_, email) {
    return GraphQlClient.mutation(`
      mutation ($email: String!){
        forgotPassword(email: $email) {
          ok
        }
      }`, { email });
  },

  forgotPasswordMigrated(_, email) {
    return GraphQlClient.mutation(`
      mutation ($email: String!){
        forgotPasswordMigrated(email: $email) {
          ok
        }
      }`, { email });
  },
};



// WEBPACK FOOTER //
// ./src/stores/auth/actions.js